import React from "react";
import { Outlet } from "react-router-dom";

function ViewStart() {
  return (
    <div className=" w-[100vw] h-screen">
      <Outlet />
    </div>
  );
}

export default ViewStart;
